@if (state$ | async; as state) {
  @if (state.loading) {
    <!-- two lines where the chains will stand (0127) -->
    <div class="bom-item-stages-part">
      <div class="bom-item-stages-line"><span class="shadow shadow-long"></span></div>
    </div>
    <div class="bom-item-stages-part">
      <div class="bom-item-stages-line"><span class="shadow"></span></div>
    </div>
  } @else {
    @for (part of visibleParts(state); track part.parentBomItemId) {
      <div class="bom-item-stages-part">
        @if (parentBomItemId() === undefined) {
          @let partLabel = part.parentName ? `do: ${part.parentName}` : 'produkt końcowy';
          <div class="bom-item-stages-part-label" [title]="partLabel">{{ partLabel }}</div>
        }

        <div class="bom-item-stages-line">
          @for (stage of part.stages; track stage.operationTypeId; let last = $last) {
            <span class="bom-item-stage"
              [class.skipped]="stage.fact === stageFact.skipped || stage.fact === stageFact.skippedByDefault"
              [class.no-fact]="stage.fact === null"
              [title]="stageTitle(stage)">{{ stage.name }}</span>

            @if (!last) {
              <span class="bom-item-stage-arrow">→</span>
            }
          }
        </div>
      </div>
    } @empty {
      <div class="bom-item-stages-empty">Brak danych z produkcji</div>
    }
  }
}
